export const PHOTO_BOX = {
	MAX_TAM_IMG: "Tamanho máximo:",
	IMG_FORMAT: "Formato:",
};